export default new Proxy({}, {
  get(_, key) {
    throw new Error(`Module "https" has been externalized for browser compatibility. Cannot access "https.${key}" in client code.  See https://vite.dev/guide/troubleshooting.html#module-externalized-for-browser-compatibility for more details.`)
  }
})